import { concat, of } from 'rxjs';

import { actions as bootstrapActions } from '@ezugi/bootstrap';

import { cardsActions } from '../../reducers/cards';
import { cardsSelector } from '../../selectors/cards';

const { roundActions } = bootstrapActions;

export default function handleCancelLastCard(socketMessage, state) {
  const { CardHand } = socketMessage;

  const { cards } = cardsSelector(state)[CardHand];
  const nextCards = [ ...cards ];
  nextCards.pop();

  return concat(
    of(
      cardsActions.cards.set({
        [CardHand]: {
          cards: nextCards,
        },
      })
    ),
    of(roundActions.round.set({ roundSkippedPYB: false }))
  );
}
